'use client';

import { AnimatePresence, motion } from 'framer-motion';
import BlogCardXL from './blogCardXL';
import BlogCardMD from './blogCardMD';
import { Divider } from '@/components/global/utils/Divider';
import { IArticle } from '@/lib/blog';

// importe o tipo correto se tiver (IArticle)

type CategoriesArticlesProps = {
  articles: IArticle[];
  className?: string;
};

const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.06,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.35,
      ease: 'easeOut',
    },
  },
};

export function CategoriesArticles({
  articles,
  className,
}: CategoriesArticlesProps) {
  if (!articles || articles.length === 0)
    return (
      <span className="font-roboto opacity-[0.45] font-medium">
        No articles found for this category.
      </span>
    );

  const first = articles[0];
  const middle = articles.slice(1, 3); // 2 artigos
  const right = articles.slice(3, 7); // até 4 artigos

  return (
    <motion.div
      className={`flex lg:flex-row flex-col lg:gap-0 gap-[2rem] items-start w-fit ${
        className ?? ''
      }`}
      variants={containerVariants}
      initial="hidden"
      animate="show"
    >
      {/* CARD XL */}
      <motion.div variants={itemVariants} className="flex-shrink-0">
        <BlogCardXL key={first?._id} article={first} />
      </motion.div>

      <Divider className="lg:block hidden" orientation="vertical" />

      <motion.ul
        className="flex flex-col lg:w-[40.375rem] w-full"
        variants={containerVariants}
      >
        {middle.map((article, index, arr) => {
          const isLast = index === arr.length - 1;

          return (
            <motion.li key={article._id} variants={itemVariants}>
              <BlogCardMD enableDescription={false} article={article} />
              {!isLast && <Divider />}
            </motion.li>
          );
        })}
      </motion.ul>

      <Divider className="lg:block hidden" orientation="vertical" />

      <motion.ul
        className="flex flex-col lg:w-[33.25rem] w-full"
        variants={containerVariants}
      >
        {right.map((article, index, arr) => {
          const isLast = index === arr.length - 1;

          return (
            <motion.li key={article._id} variants={itemVariants}>
              <BlogCardMD
                className="lg:w-[33.25rem]"
                enableImage={false}
                enableDescription={false}
                article={article}
              />
              {!isLast && <Divider />}
            </motion.li>
          );
        })}
      </motion.ul>
    </motion.div>
  );
}

export function CategorySection({
  activeCategory,
  articles,
}: {
  activeCategory: string;
  articles: IArticle[];
}) {
  return (
    <AnimatePresence mode="wait">
      <CategoriesArticles key={activeCategory} articles={articles} />
    </AnimatePresence>
  );
}
